/**
 * Augmentations module barrel export
 */

export * from "./registry";
